import JSEncrypt from 'jsencrypt'
/**
 * 加密明文密码为密文(RSA)
 * @param {String} publicKey RSA公钥
 * @param {String} password 明文密码
 */
export function RSAEncrypt(password:string, publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCfnjxaXECcrcgR0WwTjRRhdZop
0wWiegNp+B9GV5W+qNWitEPLj6wKMTwviHS0OeR9GxUV2U9AriJYJp1n4f+x+UMK
ORE+R7RElb/omVoUpAizxezc361DHViU9EmzSs/OfgFlrRSylOanSq1qxrlGOsjE
tSEOO3wCIEEkL7PvewIDAQAB
-----END PUBLIC KEY-----`) {
  // const encrypt = new window.JSEncrypt()
  const encrypt = new JSEncrypt({
    default_key_size: '1024',
  })
  encrypt.setPublicKey(publicKey)
  console.log(publicKey, encrypt.encrypt(password))
  return encrypt.encrypt(password)
}
